// import React from "react";
// import PropTypes from "prop-types";
// import { BiSortUp, BiSortDown } from "react-icons/bi"; // Import icons from react-icons

// const SortOrderButton = ({ sortOrder, toggleSortOrder, className }) => {
//   return (
//     <button
//       onClick={toggleSortOrder}
//       className={className}
//       style={{
//         border: "1px solid #007bff", // Blue border
//         background: "#f8f9fa", // Light background color
//         marginLeft: "10px",
//         borderRadius: "4px",
//         padding: "5px",
//         cursor: "pointer",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         width: "32px", // Fixed width for square button
//         height: "32px", // Fixed height for square button
//       }}
//     >
//       {sortOrder === "desc" ? (
//         <BiSortUp size={20} color="#007bff" /> // Up arrow icon

//       ) : (
//         <BiSortDown size={20} color="#007bff" /> // Down arrow icon

//       )}
//     </button>
//   );
// };

// SortOrderButton.propTypes = {
//   sortOrder: PropTypes.string.isRequired, // "asc" or "desc"
//   toggleSortOrder: PropTypes.func.isRequired, // Function to toggle sort order
//   className: PropTypes.string, // Optional className for styling
// };

// export default SortOrderButton;


import React from "react";
import PropTypes from "prop-types";
import { ReactComponent as TopPerformerIcon } from "../../../assets/icons/icons-svg/Top-performer-icon.svg";
import { ReactComponent as BottomPerformerIcon } from "../../../assets/icons/icons-svg/Bottom-performer-icon.svg";

const SortOrderButton = ({ sortOrder, toggleSortOrder, className }) => {
  const tooltipText = sortOrder === "desc" ? "Top Performing" : "Bottom Performing";
  return (
    <span className="custom-tooltip-container">
      <button
        onClick={toggleSortOrder}
        className={className}
        style={{
          border: "1px solid #11A1FD",
          background: "#f8f9fa",
          marginLeft: "10px",
          borderRadius: "4px",
          padding: "5px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "32px",
          height: "32px",
        }}
        tabIndex={0}
      >
        {sortOrder === "desc" ? (
          <TopPerformerIcon width={20} height={20} />
        ) : (
          <BottomPerformerIcon width={20} height={20} />
        )}
      </button>
      <span className="custom-tooltip">{tooltipText}</span>
    </span>
  );
};

SortOrderButton.propTypes = {
  sortOrder: PropTypes.string.isRequired,
  toggleSortOrder: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default SortOrderButton;